<!--客户池-->
<template>
  <div class="customer-pool-container" v-loading="loading">
    <div class="customer-pool-container__content default-table" :style="`height:${height_content}`">
      <el-tabs v-model="search.state_str">
        <el-tab-pane name="1">
          <el-badge slot="label" :value="statisticsMap.state_1">
            待分配
          </el-badge>
        </el-tab-pane>
        <el-tab-pane name="2">
          <el-badge slot="label" :value="statisticsMap.state_2">
            已分配
          </el-badge>
        </el-tab-pane>
        <el-tab-pane name="3">
          <el-badge slot="label" :value="statisticsMap.state_3">
            已成交
          </el-badge>
        </el-tab-pane>
        <el-tab-pane name="0">
          <el-badge slot="label" :value="statisticsMap.all">
            全部
          </el-badge>
        </el-tab-pane>
      </el-tabs>
      <div class="toolbar" style="display: flex;justify-content: space-between;align-items: center;">
        <div>
          <el-form :model="search" inline size="mini">
            <el-form-item label="">
              <el-input v-model="search.customer_name" placeholder="客户名称" clearable></el-input>
            </el-form-item>
            <template v-if="search.state===2">
              <el-form-item>
                <el-select v-model="search.follow_months" clearable placeholder="搜索未跟进时间范围"
                           @change="handelSearch">
                  <el-option :label="`超 ${item.label} 未跟进`" :value="item.value" v-for="item in followMonthRange"
                             :key="item.value"/>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="search.assign_months" clearable placeholder="搜索未成交时间范围"
                           @change="handelSearch">
                  <el-option :label="`超 ${item.label} 未成交`" :value="item.value" v-for="item in followMonthRange"
                             :key="item.value"/>
                </el-select>
              </el-form-item>
            </template>
            <el-form-item v-show="search.state==='3'">
              <el-input v-model="search.sale_name" placeholder="分配销售,模糊搜索" clearable/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handelSearch" icon="el-icon-search">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
        <toolbar-sort :fields="FieldsSort" @change="eventSort"/>
      </div>
      <el-table :data="table" height="calc(100% - 62px - 40px - 36px)" style="width: 100%" :show-header="false">
        <el-table-column width="350">
          <template
              v-slot="{row:{logo_name,pioneer_name,customer_name,logo_f_size,sale_names},row}">
            <div style="display: flex;align-items: center;">
              <div class="logo" :style="{fontSize:logo_f_size}">
                {{ logo_name }}
              </div>
              <div style="margin-left: 20px;width: calc(100% - 96px);">
                <div style="color: #45474d;font-size: 15px;font-weight: bold;">
                  <customer-detail-link :customer="row" style="color: #45474d;font-size: 15px;font-weight: bold;"/>
                </div>
                <div>开拓销售：{{ pioneer_name || '-' }}</div>
                <div>历史销售：{{ sale_names }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column>
          <template v-slot="{row:{brand_name}}">
            <div v-if="brand_name" style="max-height: 100px;overflow-y: auto;"><b>品牌：</b>{{ brand_name }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center">
          <template v-slot="{row}">
            <div style="display: flex;align-items: center;justify-content: center;">
              <div style="margin-right: 4px;">
                <div style="font-size: 16px;font-weight: 700;color: #45474d;margin-bottom: 4px;">
                  {{ row.sales_volume|numberFormatW }}
                </div>
                <div style="color: #AAAAAA;">历史销售额</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center">
          <template v-slot="{row:{last_sales_volume}}">
            <div style="font-size: 16px;font-weight: 700;color: #45474d;margin-bottom: 4px;">
              {{ last_sales_volume|numberFormatW }}
            </div>
            <div style="color: #AAAAAA;">上一年销售额</div>
          </template>
        </el-table-column>
        <el-table-column>
          <template v-slot="{row:{created_at,bef_trade_at,assign_at,state}}">
            <div>加入时间
              <el-tooltip content="加入公海客户池时间">
                <i class="el-icon-info" style="color: #AAAAAA;cursor: pointer;"/>
              </el-tooltip>
              ：{{ created_at|parseTime }}
            </div>
            <div>最后下单
              <el-tooltip content="加入公海客户池前最后下单时间">
                <i class="el-icon-info" style="color: #AAAAAA;cursor: pointer;"/>
              </el-tooltip>
              ：{{ bef_trade_at|parseTime }}
            </div>
            <div v-if="state!==(STATE_WAIT)">分配/领取：{{ assign_at|parseTime }}</div>
          </template>
        </el-table-column>
        <el-table-column v-if="search.state!==STATE_WAIT">
          <template v-slot="{row:{sale_name,follow_record,aft_trade_at,state}}">
            <div>跟进销售：{{ sale_name }}</div>
            <div>跟进记录：{{ follow_record || '暂无' }}</div>
            <div v-if="state===(STATE_SUCCESS)">成交时间：<span v-if="aft_trade_at">{{
                aft_trade_at |parseTime
              }}</span><span v-else>暂无</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="search.state===STATE_WAIT" align="center">
          <template v-slot="{row}">
            <el-button v-permission="'customer_pool_assign'" type="primary" plain round size="mini" @click="openDialogSale=true;ids=[row.id]">
              分配
            </el-button>
          </template>
        </el-table-column>
        <el-table-column v-if="search.state===2" align="center">
          <template v-slot="{row}">
            <el-button v-permission="'customer_pool_reset'" type="primary" plain round size="mini" @click="resetSale(row.id,row.customer_name)">
              撤销分配
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
          background
          :current-page="search.page"
          :page-size="search.page_size"
          layout="total, prev, pager, next"
          :total="search.total"
          style="margin-top: 10px;float: right;"
          @current-change="handleCurrentChange"
      />
    </div>
    <!--    更换销售-->
    <MatchSale :visible.sync="openDialogSale" :ids="ids" @close="init"/>
  </div>
</template>

<script>

import {CodeToText} from 'element-china-area-data'
import ToolbarSort from "@/components/ToolbarSort/index.vue";
import {getCustomerRecordList, getCustomerRecordReset, getCustomerRecordStatistics} from "../../api/customerPool";
import MatchSale from "./MatchSale.vue";
import CustomerDetailLink from "../custom/components/detail-link.vue";

const area = Object.values(CodeToText).map((_ => {
  let tmp
  tmp = _.replace(/省/g, "")
  tmp = tmp.replace(/市/g, "")
  tmp = tmp.replace(/区/g, "")
  return tmp
}))

function getStrLenShort(name) {
  const array = [/信息技术有限公司/g, /美妆有限公司/g, /传媒有限公司/g, /科技有限公司/g, /有限公司/g]
  array.forEach(item => {
    name = name.replace(item, "")
  })
  if (name.length > 8) {
    name = name.substring(0, 8)
  }
  return name
}

const FieldsSort = [
  {label: '历史销售额', field: 'sales_volume'},
  {label: '上一年销售额', field: 'last_sales_volume'},
  {label: '最后下单时间', field: 'bef_trade_at'},
  {label: '分配时间', field: 'assign_at'},
]
const STATE_WAIT = 1
const STATE_SUCCESS = 3

export default {
  name: "CustomerPool",
  components: {CustomerDetailLink, MatchSale, ToolbarSort,},
  data() {
    return {
      STATE_WAIT,
      STATE_SUCCESS,
      FieldsSort,
      table: [],
      followMonthRange: [],
      height_content: 'calc(100% - 48px - 77px)',
      statisticsMap: {all: 0, state_1: 0, state_2: 0, state_3: 0},
      loading: false,
      openDialogSale: false,//更换销售弹窗
      ids: [],
      search: {
        state_str: '1',
        state: 1,
        page: 1,
        page_size: 20,
        total: 0,
        order_by: null,
        follow_months: null,
        assign_months: null,
        customer_name: null,
      },
    }
  },
  watch: {
    "search.state_str"(_) {
      this.search.state = parseInt(_)
      this.handleCurrentChange(1)
    }
  },
  created() {
    this.init()
  },
  beforeMount() {
    window.addEventListener('resize', this.handelResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handelResize)
  },
  methods: {
    handelResize() {
      this.$nextTick(() => {
        this.height_content = `calc(100% - 32px)`
      })
    },
    init: function () {

      //初始化数据
      this.followMonthRange = []
      for (let i = 1; i <= 12; i++) {
        this.followMonthRange.push({label: `${i}个月`, value: i})
      }

      this.getData()
      this.getStatistics()
      this.handelResize()
    },
    //统计
    getStatistics() {
      getCustomerRecordStatistics().then(res => {
        let data = res.data || {}
        let list = data.list || []
        let map = {page: 1, per_page: 15, state: 1, orderBy: "`id` desc"}
        let total = 0;
        if (list.length > 0) {
          list.map((item) => {
            map[`state_${item.state}`] = item.total || 0
            total += item.total;
          })
          map['all'] = total

        }
        this.statisticsMap.all = map.all || 0
        this.statisticsMap.state_1 = map.state_1 || 0
        this.statisticsMap.state_2 = map.state_2 || 0
        this.statisticsMap.state_3 = map.state_3 || 0
      })
    },
    resetSale(id,name) {
      this.$msgbox.confirm(`是否确认将【${name}】返回公海客户池？操作成功后可以重新分配销售`, "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        //调用删除方法
        getCustomerRecordReset({ids: [id]}).then(res => {
          this.msgSuccess(res.message || '操作成功')
          this.init()
        })
      })
    },
    handleCurrentChange: function (val) {
      this.search.page = val
      this.getData()
    },
    handelSearch: function () {
      this.page = 1
      this.getData()
    },
    eventSort: function (field, sort) {
      this.search.orderBy = field ? `${field} ${sort}` : ''
      this.handelSearch()
    },
    getData: async function () {
      const _this = this
      this.loading = true
      const {data: {list, total}} = await getCustomerRecordList(this.search)
      this.loading = false
      this.search.total = total || 0
      const table = list || []
      table.map(_ => {
        _.logo_name = _this.getShortName(_.customer_name)
        _.logo_f_size = '20px'
        switch (_.logo_name.length) {
          case 4:
            _.logo_f_size = '26px'
            break;
          case 5:
            _.logo_f_size = '20px'
            break;
          case 6:
            _.logo_f_size = '20px'
            break;
          case 7:
          case 8:
          case 9:
          case 10:
            _.logo_f_size = '17px'
            break;
        }
      })
      this.table = table
    },
    getShortName: function (name) {
      for (let i = 0; i < area.length; i++) {
        let prefix = area[i]
        if (name.startsWith(prefix)) {
          name = name.substring(prefix.length)
        }
      }
      return getStrLenShort(name)
    },
  }
}
</script>
<style lang="scss">
.customer-pool-container {
  font-family: FjallaOne-Regular, sans-serif !important;
  padding: 24px;
  background: #F5F6FA;
  height: calc(100% - 48px);

  p {
    margin-block-start: 0;
    margin-block-end: 0;
  }

  .el-form {
    //border-radius: 8px;
    //background: #FFFFFF;
    //margin-bottom: 12px;
    //padding: 18px 18px 10px 18px;
  }

  .el-form-item--mini.el-form-item {
    margin-bottom: 8px !important;
  }

  &__content {
    background: #FFFFFF;
    border-radius: 8px;
    padding: 12px 30px 24px 30px;
    position: relative;
  }

  .el-pagination {
  }

  .default-table tr.el-table__row .cell {
    height: unset !important;
    line-height: unset !important;

  }

  .el-icon-notebook-2, .el-icon-connection, .el-icon-coin {
    color: #fe346e;
    margin-right: 4px;
    font-size: 14px;
    font-weight: 600;
  }

  .logo {
    font-family: FjallaOne-Regular, sans-serif !important;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 10px;
    font-size: 20px;
    font-weight: 600;
    width: 76px;
    height: 76px;
    background: #ffeef3;
    color: #fe346e;
    line-height: 1.2;
  }

  .ellipsis {
    overflow: hidden; /* 确保超出容器的内容被裁剪 */
    white-space: nowrap; /* 确保文本在一行内显示 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
  }

  .el-table td, .el-table th {
    padding: 14px 0 !important;
  }

  .el-table__row {
    cursor: pointer;
  }

  .edit-aim {
    opacity: 0;
    width: 30px;
    height: 30px;
  }

  .el-table__row:hover {
    .edit-aim {
      opacity: 1;
    }
  }

  .el-dialog {
    width: 300px;
    border-radius: 20px;

    .el-input__suffix {
      right: 12px !important;
    }
  }

  .toolbar {
    padding-bottom: 12px;
    border-bottom: 1px solid #F2F2F2;
  }

  .el-badge__content.is-fixed {
    top: 15px !important;
    right: 5px;
  }
}
</style>
